/**
 * `@spatial/storefront-extension`: what a storefront built with
 * `STOREFRONT_EXTENSIONS_MODULE` pointing here loads (PLAN.md, Contract 3).
 *
 * <p>The storefront resolves the module id `@storefront/extensions` to this
 * file and registers every theme listed below after its built-in themes. With
 * the variable unset, the storefront loads its own `none.ts` and nothing here
 * is bundled.
 */
import { spatialKitchenTheme, THEME_ID, KitchenCatalogueSurface } from '@spatial/theme-kitchen';
import type { StorefrontExtension } from './types';

export type { StorefrontExtension, ThemeBundle } from './types';

export const extensions: StorefrontExtension[] = [
  {
    id: 'spatial-kitchen',
    themes: [{ themeId: THEME_ID, bundle: spatialKitchenTheme }],
    // The kitchen designer's shopper designs, palettes and ranges go through the storefront BFF
    // (`/api/storefront/extensions/spatial/…`, SHOPPER_DESIGNS_PLAN.md).
    apiPrefixes: ['spatial'],
    plugins: ['spatial.kitchen'],
    catalogueSurface: KitchenCatalogueSurface,
  },
];

export default extensions;
